@if (layoutType == 0) {
  <div class="container pad">
    <p [innerHTML]="aboutData"> </p>
  </div>
}
@if (layoutType == 1) {
  <calsoft-layout
    [value]="3"
    [pageNated]="true"
    [homePageData]="homePageBuilder"
    [type]="2">
  </calsoft-layout>
}
